module.exports = __webpack_public_path__ + "assets/img/box4-img.31d15af9.png";